<div class="vertical-menu">
    <div class="d-flex align-items-center" style="height: 80px; padding-left: 68px;">
        <p class="mb-0 nav-link">MENU</p>
    </div>
    <a [routerLink]="['/users']" routerLinkActive="router-link-active" class="nav-link d-flex align-items-center"
        *ngxPermissionsOnly="['ROLE_MAD']">
        <div class="px-4">
            <img src="images/icons/ICON_58.svg" alt="Utenti Icon" height="24">
        </div>
        <span class="mx-2 ls-1">Utenti</span>
    </a>
    <a [routerLink]="['/groups']" routerLinkActive="router-link-active" class="nav-link d-flex align-items-center">
        <div class="px-4">
            <img src="images/icons/ICON_29.svg" alt="Gruppi Icon" height="24">
        </div>
        <span class="mx-2 ls-1">Gruppi</span>
    </a>
    <a [routerLink]="['/contexts']" routerLinkActive="router-link-active" class="nav-link d-flex align-items-center">
        <div class="px-4">
            <img src="images/icons/Contesti.svg" alt="Contesti Icon" height="24">
        </div>
        <span class="mx-2 ls-1">Contesti</span>
    </a>
    <a [routerLink]="['/utilization']" routerLinkActive="router-link-active" class="nav-link d-flex align-items-center">
        <div class="px-4">
            <img src="images/icons/ICON_6.svg" alt="Utilizzo Icon" height="24">
        </div>
        <span class="mx-2 ls-1">Utilizzo</span>
        @if (quotaSrv.alertLvl) {
        <fa-icon class="px-4" [class]="'text-' + quotaSrv.alertLvl" [icon]="faWarning"></fa-icon>
        }
    </a>

    <div class="d-flex justify-content-center align-items-center">
        <button type="button" [routerLink]="['/faq']" class="btn btn-link support-link text-body-secondary">Serve
            Aiuto?</button>
        <div class="tim-logo pt-4">
            <img class="mx-3" src="images/TIM ENTERPRISE_Orizz.Pos_RGB.svg" alt="Tim Enterprise Logo">
        </div>
    </div>

</div>